import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api/api";

export const place_order = createAsyncThunk("order/place_order", async ({ price, products, shipping_fee, items, shippingInfo, userId, navigate }, { fulfillWithValue, rejectWithValue }) => {
  try {
    if (process.env.NODE_ENV === "development") console.log("uso de  place_order  ");
    if (!userId) {
      if (process.env.NODE_ENV === "development") console.log("Se requiere ID de usuario");
      return rejectWithValue("Se requiere ID de usuario");
    }

    if (!Array.isArray(products)) {
      if (process.env.NODE_ENV === "development") console.log("Formato de productos inválido");
      return rejectWithValue("Formato de productos inválido");
    }

    if (!shippingInfo || !shippingInfo.address) {
      if (process.env.NODE_ENV === "development") console.log("Información de envío incompleta");
      return rejectWithValue("Información de envío incompleta");
    }
    if (process.env.NODE_ENV === "development")
      console.log("envio de informacion a  api place-order ", {
        price,
        products,
        shipping_fee,
        shippingInfo,
        userId,
      });
    const { data } = await api.post("/home/order/place-order", {
      price,
      products,
      shipping_fee,
      shippingInfo,
      userId,
    });
    if (process.env.NODE_ENV === "development") console.log("Respuesta del backend:", data);

    if (!data || !data.orderId) {
      if (process.env.NODE_ENV === "development") console.log("Respuesta inválida del servidor validacion place_order in order reducer");
      return rejectWithValue("Respuesta inválida del servidor validacion place_order in order reducer");
    }

    if (process.env.NODE_ENV === "development") console.log("return data.orderId-->" + data.orderId);

    // 1. Retorna los datos que el reducer necesita
    return fulfillWithValue({
      orderId: data.orderId,
      price: price + shipping_fee,
      items: items,
    });
  } catch (error) {
    // Manejo estructurado de errores
    const errorMessage = error.response?.data?.message || error.message || "Error al procesar la orden";
    // Mostrar notificación de error al usuario
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
    });

    // Puedes diferenciar entre errores de red y del servidor
    if (error.response) {
      // Error del servidor (4xx, 5xx)
      return rejectWithValue({
        message: errorMessage,
        status: error.response.status,
        data: error.response.data,
      });
    } else if (error.request) {
      // Error de red (no se recibió respuesta)
      return rejectWithValue({
        message: "Error de conexión con el servidor",
      });
    } else {
      // Error al configurar la petición
      return rejectWithValue({
        message: "Error al configurar la solicitud",
      });
    }
  }
});
// End Method

export const get_orders = createAsyncThunk("order/get_orders", async ({ customerId, status }, { rejectWithValue, fulfillWithValue }) => {
  try {
    const { data } = await api.get(`/home/coustomer/get-orders/${customerId}/${status}`);
    // console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
// End Method

export const get_order_details = createAsyncThunk("order/get_order_details", async (orderId, { rejectWithValue, fulfillWithValue }) => {
  try {
    const { data } = await api.get(`/home/coustomer/get-order-details/${orderId}`);
    // console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
// End Method

export const track_order = createAsyncThunk("order/track_order", async (orderCode, { rejectWithValue, fulfillWithValue }) => {
  try {
    const { data } = await api.get(`/home/tracking/${orderCode.toUpperCase()}`);
    return fulfillWithValue(data);
  } catch (error) {
    return rejectWithValue(error.response?.data || { error: 'No se encontró el pedido' });
  }
});
// End Method

export const orderReducer = createSlice({
  name: "order",
  initialState: {
    myOrders: [],
    errorMessage: "",
    successMessage: "",
    myOrder: {},
    orderId: null,
    trackedOrder: null,
    trackLoading: false,
    trackError: "",
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: builder => {
    builder

      .addCase(get_orders.fulfilled, (state, { payload }) => {
        state.myOrders = payload.orders;
      })
      .addCase(get_order_details.fulfilled, (state, { payload }) => {
        state.myOrder = payload.order;
      })

      .addCase(place_order.fulfilled, (state, action) => {
        state.loading = false;
        state.orderId = action.payload.orderId;
      })
      .addCase(place_order.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(track_order.pending, state => {
        state.trackLoading = true;
        state.trackError = "";
        state.trackedOrder = null;
      })
      .addCase(track_order.fulfilled, (state, { payload }) => {
        state.trackLoading = false;
        state.trackedOrder = payload.order;
      })
      .addCase(track_order.rejected, (state, { payload }) => {
        state.trackLoading = false;
        state.trackError = payload?.error || 'No se encontró el pedido';
      });
  },
});
export const { messageClear } = orderReducer.actions;
export default orderReducer.reducer;
